// @flow
import * as React from 'react';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

// Components
import Panel from 'components/atoms/Panel';
import ParseHTML from 'components/atoms/ParseHTML';
import Button from 'components/atoms/Button';

// Constants
import { SELF_CHECK_IN_FLOW } from 'constants/selfCheckIn';

import './WhiteConfirmation.scss';
const ns = 'self-checkin-white-confirmation';
const {
  NON_OPERATING_HOURS_CHECK_IN,
  NON_OPERATING_HOURS_ADDITIONAL_SERVICE_CHECK_IN
} = SELF_CHECK_IN_FLOW;

type Props = {
  intl: IntlShape,
  statusTrackerURL?: string,
  selfCheckInFlow: string
};

type State = {
  animationFlag: boolean
};

class WhiteConfirmation extends React.Component<Props, State> {
  state = {
    animationFlag: false
  };

  componentDidMount() {}

  render() {
    const { intl, statusTrackerURL, selfCheckInFlow } = this.props;
    let finalInstructions = intl.formatMessage({
      id: 'c8.self.check.in.config.final.instructions',
      defaultMessage:
        '<ul>' +
        '<li>Parking is open except for the Service Drive Lane</li>' +
        '<li>Keys can be dropped off with any advisor or in the service department drop box</li>' +
        '<li>To speak with a service advisor, complete checking in and indicate your preferred method of contact</li>' +
        '</ul>'
    });
    if (
      selfCheckInFlow === NON_OPERATING_HOURS_CHECK_IN ||
      selfCheckInFlow === NON_OPERATING_HOURS_ADDITIONAL_SERVICE_CHECK_IN
    ) {
      finalInstructions = intl.formatMessage({
        id: 'c8.self.check.in.config.extended.final.instructions',
        defaultMessage:
          '<ul>' +
          '<li>Please park your vehicle in designated location</li>' +
          '<li>Drop the keys in the provided envelope in the drop box</li>' +
          '<li>An advisor will call you during regular business hours to confirm check in</li>' +
          '</ul>'
      });
    }
    return (
      <div className={`${ns}`}>
        {statusTrackerURL && (
          <Button
            className={`${ns}__button`}
            onClick={() => {
              window.open(statusTrackerURL);
            }}
          >
            {intl.formatMessage({
              id: 'c8.self.check.in.common.check.status',
              defaultMessage: 'CHECK STATUS'
            })}
          </Button>
        )}
        <div className={`${ns}__sub-title`}>
          {intl.formatMessage({
            id: 'c8.self.check.in.confirmation.page.instruction.message'
          })}
        </div>
        <Panel>
          <ParseHTML className={`${ns}__paragraphs`} html={finalInstructions} />
        </Panel>
      </div>
    );
  }
}

export default WhiteConfirmation;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ConfirmationPage/components/WhiteConfirmation/WhiteConfirmation.js